// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2LeRi","container":"Modal_container__3p5ir","content":"Modal_content__3O8Pu"};